import { createAction, props } from '@ngrx/store';
import {AttributeLocaleFields, Locale, LocaleMappings, LocaleUpdateFields} from '@emm/core/models/locale.model';

export enum LocalesAction {
    Init = '[Locales] Init',
    LoadAttributeLocaleFields = '[Locales] Load Attribute Locale Fields',
    LoadAttributeLocaleFieldsFailure = '[Locales] Load Attribute Locale Fields Failure',
    LoadAttributeLocaleFieldsSuccess = '[Locales] Load Attribute Locale Fields Success',
    LoadLocaleMappings = '[Locales] Load Locale Mappings',
    LoadLocaleMappingsFailure = '[Locales] Load Locale Mappings Failure',
    LoadLocaleMappingsSuccess = '[Locales] Load Locale Mappings Success',
    LoadLocaleOptions = '[Locales] Load Locale Options',
    LoadLocaleOptionsFailure = '[Locales] Load Locale Options Failure',
    LoadLocaleOptionsSuccess = '[Locales] Load Locale Options Success',
    ResetSaved = '[Locales] Reset Saved',
    SaveAttributeLocaleFields = '[Locales] Save Locale Attribute Updates',
    SaveAttributeLocaleFieldsFailure = '[Locales] Save Locale Attribute Failure',
    SaveAttributeLocaleFieldsSuccess = '[Locales] Save Locale Attribute Success',
    SelectedAttributeLocales = '[Locales] Selected Attribute Locales',
    SelectedLocale = '[Locales] Selected Locale'
}

export const LocalesActions = {

    localeInit: createAction(LocalesAction.Init),

    loadAttributeLocaleFields: createAction(LocalesAction.LoadAttributeLocaleFields, props<{ attributeTag: string, itemTag: string }>()),
    loadAttributeLocaleFieldsFailure: createAction(LocalesAction.LoadAttributeLocaleFieldsFailure, props<{ error: any }>()),
    loadAttributeLocaleFieldsSuccess: createAction(LocalesAction.LoadAttributeLocaleFieldsSuccess,
        props<{ attributeLocaleFields: AttributeLocaleFields }>()),

    loadLocaleMappings: createAction(LocalesAction.LoadLocaleMappings),
    loadLocaleMappingsFailure: createAction(LocalesAction.LoadLocaleMappingsFailure, props<{ error: any }>()),
    loadLocaleMappingsSuccess: createAction(LocalesAction.LoadLocaleMappingsSuccess, props<{ localeMappings: LocaleMappings }>()),

    loadLocaleOptions: createAction(LocalesAction.LoadLocaleOptions),
    loadLocaleOptionsFailure: createAction(LocalesAction.LoadLocaleOptionsFailure, props<{ error: any }>()),
    loadLocaleOptionsSuccess: createAction(LocalesAction.LoadLocaleOptionsSuccess, props<{ localeOptions: Locale[] }>()),

    resetSaved: createAction(LocalesAction.ResetSaved),

    saveAttributeLocaleFields: createAction(LocalesAction.SaveAttributeLocaleFields,
        props<{ itemTag: string, updatedFields: LocaleUpdateFields[], origin: string }>()),
    saveAttributeLocaleFieldsFailure: createAction(LocalesAction.SaveAttributeLocaleFieldsFailure, props<{ error: any }>()),
    saveAttributeLocaleFieldsSuccess: createAction(LocalesAction.SaveAttributeLocaleFieldsSuccess, props<{ itemTag: string}>()),

    selectedAttributeLocales: createAction(LocalesAction.SelectedAttributeLocales,
        props<{ attributeLocalesFields: AttributeLocaleFields }>()),
    selectedLocale: createAction(LocalesAction.SelectedLocale, props<{ locale: Locale }>())
};

export const AsyncActions = {
    loadActions: [
        LocalesActions.loadAttributeLocaleFields,
        LocalesActions.loadLocaleMappings,
        LocalesActions.loadLocaleOptions
    ],
    successActions: [
        LocalesActions.loadAttributeLocaleFieldsSuccess,
        LocalesActions.loadLocaleMappingsSuccess,
        LocalesActions.loadLocaleOptionsSuccess
    ],
    errorActions: [
        LocalesActions.loadAttributeLocaleFieldsFailure,
        LocalesActions.loadLocaleMappingsFailure,
        LocalesActions.loadLocaleOptionsFailure
    ]
};
